import { render, staticRenderFns } from "./SpouseTransfer.vue?vue&type=template&id=61c1bc8a&scoped=true&"
import script from "./SpouseTransfer.vue?vue&type=script&lang=javascript&"
export * from "./SpouseTransfer.vue?vue&type=script&lang=javascript&"
import style0 from "./SpouseTransfer.vue?vue&type=style&index=0&id=61c1bc8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1bc8a",
  null
  
)

export default component.exports